export default "__VITE_ASSET__CMPBT3yf__";